/**
 * Post Office message template ID for the reintroduction modal. Post Office owns
 * audience targeting, dismissal, and fatigue for this template; the launcher
 * shows the modal whenever a message is returned for it.
 *
 * TODO: confirm the template ID registered in Post Office before rollout.
 */
export const MESSAGE_TEMPLATE_ID = 'rovo-reintroduction-modal';

/**
 * Growth initiative used to attribute the modal's analytics events.
 * TODO: confirm the owning team's growth initiative before rollout.
 */
export const GROWTH_INITIATIVE = 'ai-mate';

/** Source tag attached to the rovo-triggers `chat-new` event. */
export const CHAT_OPEN_SOURCE = 'rovo-reintroduction-modal';
